import './bootstrap';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-luxon';
window.Chart = Chart;

// Import custom scripts
import './progress-chart';
import './countdown-timer';
import './welcome-modal';

var menu_btn = document.querySelector("#menu-btn");
var sidebar = document.querySelector("#sidebar");
var container = document.querySelector(".my-container");
// menu_btn.addEventListener("click", () => {
//     sidebar.classList.toggle("active-nav");
//     container.classList.toggle("active-cont");
// });
